import React from "react";
import "./BlogSongs.css";
import BlogSongsBody from "./BlogSongsBody";

function BlogSongs() {
  return (
    <div className="blogSongs">
      <BlogSongsBody />
    </div>
  );
}

export default BlogSongs;
